import _toConsumableArray from "/builds/impactobservatory/io-platform/marapp-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/builds/impactobservatory/io-platform/marapp-frontend/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @name ranges-merge
 * @fileoverview Merge and sort string index ranges
 * @version 8.2.7
 * @author Roy Revelt, Codsen Ltd
 * @license MIT
 * {@link https://codsen.com/os/ranges-merge/}
 */
import { rSort as p } from "ranges-sort";
var u = "8.2.7";
var f = u,
    d = {
  mergeType: 1,
  progressFn: null,
  joinRangesThatTouchEdges: !0
};

function b(i, t) {
  function a(e) {
    return !!e && typeof e == "object" && !Array.isArray(e);
  }

  if (!Array.isArray(i) || !i.length) return null;
  var n;
  if (t) {
    if (a(t)) {
      if (n = _objectSpread(_objectSpread({}, d), t), n.progressFn && a(n.progressFn) && !Object.keys(n.progressFn).length) n.progressFn = null;else if (n.progressFn && typeof n.progressFn != "function") throw new Error("ranges-merge: [THROW_ID_01] opts.progressFn must be a function! It was given of a type: \"".concat(typeof n.progressFn, "\", equal to ").concat(JSON.stringify(n.progressFn, null, 4)));
      if (![1, 2, "1", "2"].includes(n.mergeType)) throw new Error("ranges-merge: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: \"".concat(typeof n.mergeType, "\", equal to ").concat(JSON.stringify(n.mergeType, null, 4)));
      if (typeof n.joinRangesThatTouchEdges != "boolean") throw new Error("ranges-merge: [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: \"".concat(typeof n.joinRangesThatTouchEdges, "\", equal to ").concat(JSON.stringify(n.joinRangesThatTouchEdges, null, 4)));
    } else throw new Error("emlint: [THROW_ID_03] the second input argument must be a plain object. It was given as:\n".concat(JSON.stringify(t, null, 4), " (type ").concat(typeof t, ")"));
  } else n = _objectSpread({}, d);
  var l = i.filter(function (e) {
    return Array.isArray(e);
  }).map(function (e) {
    return _toConsumableArray(e);
  }).filter(function (e) {
    return e[2] !== void 0 || e[0] !== e[1];
  }),
      s,
      o,
      r;
  n.progressFn ? s = p(l, {
    progressFn: function progressFn(e) {
      r = Math.floor(e / 5), r !== o && (o = r, n.progressFn(r));
    }
  }) : s = p(l);
  var g = s.length - 1;

  for (var e = g; e > 0; e--) {
    n.progressFn && (r = Math.floor((1 - e / g) * 78) + 21, r !== o && r > o && (o = r, n.progressFn(r))), (s[e][0] <= s[e - 1][0] || !n.joinRangesThatTouchEdges && s[e][0] < s[e - 1][1] || n.joinRangesThatTouchEdges && s[e][0] <= s[e - 1][1]) && (s[e - 1][0] = Math.min(s[e][0], s[e - 1][0]), s[e - 1][1] = Math.max(s[e][1], s[e - 1][1]), s[e][2] !== void 0 && (s[e - 1][0] >= s[e][0] || s[e - 1][1] <= s[e][1]) && s[e - 1][2] !== null && (s[e][2] === null && s[e - 1][2] !== null ? s[e - 1][2] = null : s[e - 1][2] != null ? +n.mergeType == 2 && s[e - 1][0] === s[e][0] ? s[e - 1][2] = s[e][2] : s[e - 1][2] += s[e][2] : s[e - 1][2] = s[e][2]), s.splice(e, 1), e = s.length);
  }

  return s.length ? s : null;
}

export { d as defaults, b as rMerge, f as version };